<template>
  <div class="signature-document-container">
    <b-icon
      v-if="file"
      icon-pack="fa"
      icon="check-circle"
      class="is-green-icon"
    />
    <b-icon v-else icon-pack="fa" icon="times-circle" class="is-red-icon" />

    <label class="ml-2">{{ document.name }}</label>

    <div class="is-pulled-right">
      <b-upload v-model="file">
        <span class="file-cta button is-blue">
          {{ $t("bnpl:application.signature.modal.button.upload") }}
        </span>
      </b-upload>
    </div>

    <p class="mt-2">
      <span v-if="file" class="uploaded-file-container">
        <label>
          {{ file.name }}
        </label>

        <span class="ml-auto">
          <span class="cursor-pointer" @click="deleteFile">
            <b-icon
              icon-pack="fa"
              icon="trash"
              type="is-red"
              class="mr-2"
            ></b-icon>
          </span>

          <span class="cursor-pointer" @click="downloadFile">
            <b-icon
              icon-pack="fa"
              icon="download"
              type="is-blue"
              class="mr-2"
            ></b-icon>
          </span>
        </span>
      </span>
      <label v-else class="is-red-icon">
        {{ $t("bnpl:application.signature.modal.message.required") }}
      </label>
    </p>
  </div>
</template>

<script>
import FileSaver from "file-saver";

export default {
  name: "BnplApplicationSignatureDocumentUpload",
  components: {},
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      file: null,
    };
  },
  methods: {
    async downloadFile() {
      FileSaver.saveAs(this.file);
    },
    async deleteFile() {
      this.file = null;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/scss/colors";

.signature-document-container {
  border-bottom: 1px solid #cbd5e1;
  padding-bottom: 0.5rem;

  .file-cta.button.is-blue {
    height: 1.75rem;
  }

  .uploaded-file-container {
    display: flex;
    background-color: $grey-border;
    padding: 0.25rem 0.75rem;
    border-radius: 6px;
  }
}

.is-red-icon {
  color: $red;
}

.is-green-icon {
  color: $green;
}
</style>
